const ErrorPage = () => {
    return <>
        <h1>Error</h1>
    </>;
}

export default ErrorPage;